import { useEffect, useState } from 'react';
import { type Control, useWatch } from 'react-hook-form';

import { VALIDATION_TRIGGER_ARRAY, stepCountItemsData } from '../constants';
import type { CreateLeasingProps } from '../form-types';

type TProps = {
  control: Control<CreateLeasingProps>;
};

const useStepCount = ({ control }: TProps) => {
  const [stepCountItems, setStepCountItems] = useState(stepCountItemsData);

  const firstStepValues = useWatch({
    control,
    name: VALIDATION_TRIGGER_ARRAY[0]
  });
  const secondStepValues = useWatch({
    control,
    name: VALIDATION_TRIGGER_ARRAY[1]
  });

  useEffect(() => {
    const filledFields = firstStepValues.filter((item) => {
      if (Array.isArray(item)) return false;
      return Boolean(item);
    });

    let validArraysCount = 0;
    const arrays = firstStepValues.filter((item) => Array.isArray(item));
    if (arrays) {
      arrays.forEach((arr) => {
        if (!Array.isArray(arr)) return;
        arr.forEach((item) => {
          const values = Object.values(item);
          const filteredValues = values.filter((value) => !value);
          if (filteredValues.length === 0) {
            validArraysCount++;
          }
        });
      });
    }

    const newStepCountItems = stepCountItems.slice();
    if (
      filledFields.length + validArraysCount !==
      newStepCountItems[0].validFields
    ) {
      newStepCountItems[0].validFields = filledFields.length + validArraysCount;
      setStepCountItems(newStepCountItems);
    }
  }, [firstStepValues, stepCountItems]);

  useEffect(() => {
    const filledFields = secondStepValues.filter(Boolean);
    const newStepCountItems = stepCountItems.slice();
    if (filledFields.length !== newStepCountItems[1].validFields) {
      newStepCountItems[1].validFields = filledFields.length;
      setStepCountItems(newStepCountItems);
    }
  }, [secondStepValues, stepCountItems]);

  const incrementMaxFieldsCount = (index: number) => {
    const newStepCountItems = stepCountItems.slice();
    newStepCountItems[index].totalFields += 1;
    setStepCountItems(newStepCountItems);
  };

  const decrementMaxFieldsCount = (index: number) => {
    const newStepCountItems = stepCountItems.slice();
    newStepCountItems[index].totalFields -= 1;
    setStepCountItems(newStepCountItems);
  };

  return { stepCountItems, incrementMaxFieldsCount, decrementMaxFieldsCount };
};

export default useStepCount;
